// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1WmPU","inner":"Form_inner__1118q","range":"Form_range__2twxf","name":"Form_name__2HhR_","actions":"Form_actions__2Rsgd"};